<template>
  <div class="contentModal">
    <div class="cardProcessRrim">
      <div class="title">
        <h3>Informações Gerais</h3>
        <i class="fas fa-info-circle"></i>
      </div>
      <InformacaoGerais
        :configInputs="configInputs"
        @OBJ_Infor_Geral="getObjInforGeral"
        @mapMoldSap="getCavityMolde"

      />
    </div>

    <div class="cardProcessRrim">
      <div class="title">
        <h3>Produtos</h3>
        <i class="fas fa-info-circle"></i>
      </div>
      <Produtos
        :configInputs="configInputs"
        @sendListaDeProdutos="getListPro"
      />
    </div>

    <div class="cardProcessRrim">
      <div class="title">
        <h3>Molde Fechado</h3>
        <i class="fas fa-info-circle"></i>
      </div>
      
      <MoldeFechado
        :configInputs="configInputs"
        @dataMoldeFechado="getdataMoldeFechado"
      />
    </div>

    <div class="cardProcessRrim">
      <div class="title">
        <h3>Molde Aberto</h3>
        <i class="fas fa-info-circle"></i>
      </div>

      <MoldeAberto
        :Cavity="Cavity"
        :configInputs="configInputs"
        @dataMoldeAberto="getDataMoldeAberto"
        @setCavity="getCavityTOTAL"
      />
    </div>
  </div>
</template>

<script>
import InformacaoGerais from "./Modules/Informacao-Gerais.vue";
import MoldeAberto from "./Modules/Molde-Aberto.vue";
import MoldeFechado from "./Modules/Molde-Fechado.vue";
import Produtos from "./Modules/Produtos.vue";

export default {
  components: { InformacaoGerais, MoldeAberto, MoldeFechado, Produtos },
  data() {
    return {
      t: "",
      Cavity: 0,
    };
  },
  props: {
    configInputs: Number,
  },
  methods: {
    getObjInforGeral(Obj) {
      this.$emit("setObjOfInforGeral", Obj);
    },

    getListPro(List) {
      this.$emit("setListPro", List);
    },

    getdataMoldeFechado(Obj) {
      this.$emit("setObjMoldeFechado", Obj);
    },

    getDataMoldeAberto(Obj) {
      this.$emit("setObjMoldeAberto", Obj);
    },
    getCavityMolde(cavity){
      this.Cavity = cavity

    },
    getCavityTOTAL(cavity){
      this.$emit("setCavity", cavity);
    }
  },
};
</script>

<style scoped>
.contentModal {
  height: 100%;
  padding: 1rem 2rem;
  transition: 0.5s;
}

.contentModal .cardProcessRrim {
  width: 100%;
  position: relative;
  padding: 0.5rem;
  background-color: var(--white);
  margin: 1rem 0;
  border-radius: 0.4rem;
}

.contentModal .cardProcessRrim .title {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--green);
  color: var(--white);
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
}

@media (max-width: 425px) {
  .contentModal {
    padding: 20px 20px 0px 20px;
  }

  .contentModal .cardProcessRrim .title {
    font-size: 1rem;
  }
}
</style>
